import { Injectable } from '@angular/core';
import { Http, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/toPromise';


let apiUrl = environment.apiUrl;

@Injectable()
export class GithubService {
  constructor(private http: Http) {}

  getOrg(org: string) {
    return this.makeRequest(`orgs/${org}`);
  }

  getOptedInUsers() {
    return this.makeRequest(`repos/Chippd/mydevportfolio-optin/stargazers`)
  }

  isOptedInUser(user: string){
    console.log(`Checking if ${user} is opted in`);

    let url = apiUrl + `opted?u=${user}`;

    console.log('url:', url)

    return this.http.get(url)
      .toPromise()
      // .map((res) => res.json())
  }

  getReposForUser(user: string) {
    return this.makeRequest(`users/${user}/repos`);
  }

  getRepoForOrg(org: string, repo: string) {
    return this.makeRequest(`repos/${org}/${repo}`);
  }

  private makeRequest(path: string) {
    // let params = new URLSearchParams();
    // params.set('per_page', '100');

    let url = `https://api.github.com/${ path }`;
    console.log('making request:', url);
    return this.http.get(url)
      .map((res) => res.json());
  }

  exchangeToken(code: string, state:string){

    let url = `${apiUrl}auth?code=${code}&state=${state}`;

    return this.http.get(url)
  }

  deployPagesSite(obj){
    let url = `${apiUrl}deploytogit`;
    console.log('making deploy request with url:', url);
    console.log("obj is:", obj);
    return this.http.post(url, obj);
  }

  getUserInfo(userName: string) {
    return this.makeRequest(`users/${userName}`)
  }

  getAuthedUserInfo(token: string){
    return this.makeRequest(`user?access_token=${token}`)
  }

  getAuthedUserRepos(token: string){
    return this.makeRequest(`user/repos?access_token=${token}&per_page=100`);
  }

  getAuthedUserEmails(token: string){
    return this.makeRequest(`user/emails?access_token=${token}`)
  }

  getDeviconsJson(){
    let url = 'https://raw.githubusercontent.com/konpa/devicon/master/devicon.json'
    return this.http.get(url)
  }

  getFileContents(owner, repo, token: string, fileName){
    return this.makeRequest(`repos/${owner}/${repo}/contents/${fileName}`)
    .toPromise()
  }

  updateFileContents(owner, repo, token, data, fileName){
    // PUT /repos/:owner/:repo/contents/:path
  let url = `https://api.github.com/repos/${owner}/${repo}/contents/${fileName}`;
    
  const headers = new Headers();
  headers.append('Authorization', "token "+token);

  const options = new RequestOptions({headers: headers});
  
  return this.http.put(url, data, options)
    .map((res) => res.json())
  }
}



// WEBPACK FOOTER //
// ./src/app/services/github.service.ts